export const SPACESHIP_HASH = "0x51CC29489f6bd02aD572Cbd395ad9aC8a138aeBb"; // "0x1C713C99fB1d02237FC7b0bb3f043867ccD79b87"; //
export const MEDIUM = 768;
export const LARGE = 1024;
export const EXTRA_LARGE = 1300;
export const MOBILE = 0;
